module.exports = __webpack_public_path__ + "static/media/Tomas-Sareklint.8eb314ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/Tomas-Sareklint.jpg
// module id = 96
// module chunks = 0